import { lazy } from "react"
import { Navigate } from "react-router-dom"

const Permission = lazy(() => import("../../pages/Permission"))
const PermissionDetail = lazy(() => import("../../pages/Permission/PermissionDetail"))

const SurveillanceIndex = lazy(() => import("../../pages/Surveillance"))
const CaseList = lazy(() => import("../../pages/Surveillance/CaseList"))
const CaseDetail = lazy(() => import("../../pages/Surveillance/CaseDetail"))
const CaseBaseline = lazy(() => import("../../pages/Surveillance/CaseBaseline"))
const CaseFollowups = lazy(() => import("../../pages/Surveillance/CaseFollowups"))
const CaseDiagnosis = lazy(() => import("../../pages/Surveillance/CaseDiagnosis"))
const CaseForm = lazy(() => import("../../pages/Surveillance/CaseForm"))

function HomeRedirect() {
  return <Navigate to="/surveillance/dashboard" replace />
}

function SurveillanceRedirect() {
  return <Navigate to="/surveillance/dashboard" replace />
}

function SettingsRedirect() {
  return <Navigate to="/surveillance/settings/wards" replace />
}

function pageList() {
  return [
    {
      Element: HomeRedirect,
      path: "/dashboard",
      code: "HOME_CONTROLLER"
    },
    {
      Element: Permission,
      path: "/staff/:tab",
      code: "STAFF_CONTROLLER"
    },
    {
      Element: PermissionDetail,
      path: "/staff/groups/:id/:name",
      code: "STAFF_CONTROLLER"
    },
    // Giám sát NKVM – đường dẫn cụ thể trước
    {
      Element: CaseForm,
      path: "/surveillance/cases/new",
      code: "SURVEILLANCE"
    },
    {
      Element: CaseForm,
      path: "/surveillance/cases/:id/edit",
      code: "SURVEILLANCE"
    },
    {
      Element: CaseDiagnosis,
      path: "/surveillance/cases/:id/diagnosis",
      code: "SURVEILLANCE"
    },
    {
      Element: CaseFollowups,
      path: "/surveillance/cases/:id/followups",
      code: "SURVEILLANCE"
    },
    {
      Element: CaseBaseline,
      path: "/surveillance/cases/:id/baseline",
      code: "SURVEILLANCE"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/cases/proposed",
      code: "SURVEILLANCE"
    },
    {
      Element: CaseDetail,
      path: "/surveillance/cases/:id",
      code: "SURVEILLANCE"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/dashboard",
      code: "SURVEILLANCE"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/cases",
      code: "SURVEILLANCE"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/reports",
      code: "SURVEILLANCE"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/audit-logs",
      code: "SETTINGS_NKVM"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/settings/audit-logs",
      code: "SETTINGS_NKVM"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/settings/wards",
      code: "SETTINGS_NKVM"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/settings/surgery-types",
      code: "SETTINGS_NKVM"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/settings/antibiotics",
      code: "SETTINGS_NKVM"
    },
    {
      Element: SurveillanceIndex,
      path: "/surveillance/settings/rules",
      code: "SETTINGS_NKVM"
    },
    {
      Element: () => <Navigate to="/surveillance/settings/wards" replace />,
      path: "/surveillance/settings",
      code: "SETTINGS_NKVM"
    },
    {
      Element: SurveillanceRedirect,
      path: "/surveillance",
      code: "SURVEILLANCE"
    }
  ]
}

export default pageList
